__turbopack_context__.v({
  "back": "CardFlip-module-scss-module__4i3VZa__back",
  "backContent": "CardFlip-module-scss-module__4i3VZa__backContent",
  "backParagraph": "CardFlip-module-scss-module__4i3VZa__backParagraph",
  "card": "CardFlip-module-scss-module__4i3VZa__card",
  "cardFaceBtn": "CardFlip-module-scss-module__4i3VZa__cardFaceBtn",
  "fade-in": "CardFlip-module-scss-module__4i3VZa__fade-in",
  "front": "CardFlip-module-scss-module__4i3VZa__front",
  "frontText": "CardFlip-module-scss-module__4i3VZa__frontText",
  "image": "CardFlip-module-scss-module__4i3VZa__image",
  "inner": "CardFlip-module-scss-module__4i3VZa__inner",
  "isFlipped": "CardFlip-module-scss-module__4i3VZa__isFlipped",
  "isFlipping": "CardFlip-module-scss-module__4i3VZa__isFlipping",
  "toggleBtn": "CardFlip-module-scss-module__4i3VZa__toggleBtn",
  "toggleBtnIcon": "CardFlip-module-scss-module__4i3VZa__toggleBtnIcon",
});
